/**
 * PREVIEW COMPANY PANEL TEMPLATE
 *
 *
 * @version 0.1
 */
/**
 * PREVIEW COMPANY PANEL TEMPLATE
 *
 *
 * @version 0.1
 */

import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import utils from './../../../../utils/utilities';

import popupActions from './../../../../reusable/MessagePopup/redux/MessagePopup.actions';

import { POPUP_LIFETIME } from './../../../../constants';
import EditEntityPersonSearch from "../../../EditThirdParty/components/EditEntityPersonSearch";
import EditEntityCompanySearch from "../../../EditThirdParty/components/EditEntityCompanySearch";

let actions = null;

class PreviewEntityPanel extends React.Component {

    constructor(props) {
        super(props);

        actions = this.props.actions;

        this.addButtonHandler = this.addButtonHandler.bind(this);
        this.removeButtonHandler = this.removeButtonHandler.bind(this);
        this.checkButtonEnabled = this.checkButtonEnabled.bind(this);
        this.renderPanelSection = this.renderPanelSection.bind(this);

        this.updateCompanyData = this.updateCompanyData.bind(this);
    }

    checkButtonEnabled(event, inputField) {

        let input     = event ? event.target : inputField,
            addButton = input.parentElement.getElementsByClassName('js-add-label-button')[0];

        if (input.value.length > 0) {
            if (addButton.classList.contains('disabled')) {
                addButton.classList.remove('disabled');
            }
        } else if (!addButton.classList.contains('disabled')) {
            addButton.classList.add('disabled');
        }

    }

    updateCompanyData(field, event) {
        if (this.props.updateCompanyData) {
            this.props.updateCompanyData(field, event);
        }
        this.props.showRefreshDialog();
    }

    addButtonHandler(event) {

        // This is required in case event.target is the <span> inside the button and not the button itself.
        let button = event.target.hasAttribute('data-changed-labels') ? event.target : event.target.parentElement;

        let labelsFieldName = button.getAttribute('data-changed-labels'),
            inputObject     = document.getElementById('panel-input-' + labelsFieldName),
            input           = inputObject.value.trim(),
            fieldLabels     = this.props.companyData[labelsFieldName];

        if (input.length > 0 && utils.isArray(fieldLabels)) {

            // In case of labels other than company names, we pass a case insensitive function to the "inArray" method.
            let caseInsensitive = labelsFieldName === 'companyNames' ? null : (value) => value.toLowerCase();

            if (utils.inArray(input, fieldLabels, null, caseInsensitive) === -1) {
                actions.addLabel(
                    this.props.companyData,
                    labelsFieldName,
                    input
                ).then(() => {

                    // Clear the input value
                    inputObject.value = '';

                    // Forcibly trigger the onChange event to make the "Add" button inactive
                    this.checkButtonEnabled(null, inputObject);

                    // Show the refresh dialog
                    this.props.showRefreshDialog();

                });
            } else {

                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'Entities_Preview_Error_previewCompanies.labelExists',
                            messageType: 'info'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);

            }

        }

    }

    removeButtonHandler(event) {

        let label           = event.target,
            labelIndex      = parseInt(label.getAttribute('data-label-index'), 10),
            labelsArrayName = label.getAttribute('data-labels-array'),
            labelsArray     = this.props.companyData[labelsArrayName];

        if (!isNaN(labelIndex) && utils.isArray(labelsArray) && labelIndex >= 0 && labelIndex < labelsArray.length) {

            if (labelsArrayName === 'companyNames' && labelsArray.length === 1) {

                // Show info message on how at least 1 name must be available.
                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'Entities_Preview_Error_previewCompanies.labelDeleteErrorLastElement',
                            messageType: 'info'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);

            } else {
                actions.removeLabel(
                    this.props.companyData,
                    labelsArrayName,
                    labelIndex
                ).then(() => {
                    this.props.showRefreshDialog();
                });
            }

        }

    }

    renderPanelSection(section, panelTitleMessage, caseSensitiveMessage) {

        if (this.props.companyData && this.props.companyData[section]) {

            let labelNames = this.props.companyData[section],
                labels     = [];

            for (let i = 0; i < labelNames.length; i++) {

                labels.push(
                    <span className="tags-label notranslate" title={labelNames[i]} key={section + '-' + i } >
                        {labelNames[i]}
                        <span className="tags-label__close-button la-CloseRemove"
                              data-label-index={i}
                              data-labels-array={section}
                              onClick={this.removeButtonHandler}>
                        </span>
                    </span>
                );

            }

            return (
                <div className="panel-section">

                    <div className="panel-section__title">
                        <FormattedMessage id={panelTitleMessage} />
                    </div>

                    <div className="panel-section__existing-data">
                        {labels.length > 0 ? labels : null}
                    </div>

                    <div className="panel-section__input-add">
                        <input type="text"
                               id={'panel-input-' + section}
                               className="notranslate"
                               placeholder={this.props.intl.formatMessage({id: 'Entities_Preview_UIText_previewCompanies.panel.enterWordOrPhrase'})}
                               onChange={this.checkButtonEnabled} />
                        <button type="button"
                                data-changed-labels={section}
                                className="button-primary-sm js-add-label-button disabled"
                                onClick={this.addButtonHandler}>
                            <FormattedMessage id="Entities_Preview_UIText_previewCompanies.panel.add" />
                        </button>
                    </div>

                    <div className="panel-section__disclaimer">
                        <FormattedMessage id={caseSensitiveMessage} />
                    </div>

                </div>
            );

        } else {
            // return null;

            let labels     = [];

            return (
                <div className="panel-section">

                    <div className="panel-section__title">
                        <FormattedMessage id={panelTitleMessage} />
                    </div>

                    <div className="panel-section__existing-data">
                        {labels.length > 0 ? labels : null}
                    </div>

                    <div className="panel-section__input-add">
                        <input type="text"
                               id={'panel-input-' + section}
                               className="notranslate"
                               placeholder={this.props.intl.formatMessage({id: 'Entities_Preview_UIText_previewCompanies.panel.enterWordOrPhrase'})}
                               onChange={this.checkButtonEnabled} />
                        <button type="button"
                                data-changed-labels={section}
                                className="button-primary-sm js-add-label-button disabled"
                                onClick={this.addButtonHandler}>
                            <FormattedMessage id="Entities_Preview_UIText_previewCompanies.panel.add" />
                        </button>
                    </div>

                    <div className="panel-section__disclaimer">
                        <FormattedMessage id={caseSensitiveMessage} />
                    </div>

                </div>
            )
        }

    }

    render() {

        return (
            <form className="preview-company__panel">

                <div className="panel-inner">

                    <div className="panel-title edit-company">

                        <span className="edit-company__description">
                            <FormattedMessage id="Entities_Preview_UIText_previewCompanies.panel.editCompany" />
                        </span>

                        {this.props.toggleEditCompanyPanel ?
                            <span className="close la-CloseRemove"
                                  onClick={this.props.toggleEditCompanyPanel} /> : null}
                    </div>

                    <div className="panel-section__container">
                        <div className="panel-section">

                            <div className="panel-section__title">
                                <FormattedMessage id="Entities_Preview_UIText_previewCompanies.panel.entityType" />
                            </div>

                            <div className="person-company-check">
                                <EditEntityPersonSearch
                                    personSearch={this.props.companyData ? this.props.companyData.personSearch : true}
                                    onBlur={this.updateCompanyData} />
                                <EditEntityCompanySearch
                                    companySearch={this.props.companyData ? this.props.companyData.companySearch : true}
                                    onBlur={this.updateCompanyData} />
                            </div>

                        </div>

                        {
                            this.renderPanelSection(
                                'companyNames',
                                'Entities_Preview_UIText_previewCompanies.panel.nameAndVariants',
                                'Entities_Preview_UIText_previewCompanies.panel.caseSensitive'
                            )
                        }

                        {
                            this.renderPanelSection(
                                'contextKeywords',
                                'Entities_Preview_UIText_previewCompanies.panel.keywordsInclude',
                                'Entities_Preview_UIText_previewCompanies.panel.notCaseSensitive'
                            )
                        }

                        {
                            this.renderPanelSection(
                                'exclusionKeywords',
                                'Entities_Preview_UIText_previewCompanies.panel.keywordsExclude',
                                'Entities_Preview_UIText_previewCompanies.panel.notCaseSensitive'
                            )
                        }
                    </div>

                    <div className="panel-section__custom-content">
                        {this.props.children}
                    </div>
                </div>

            </form>
        );

    }

}

export default injectIntl(PreviewEntityPanel);


// WEBPACK FOOTER //
// ./src/scripts/pages/CreateNewEntity/EditEntitySearchParameters/Panel/PreviewEntityPanel.jsx